export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70bd147fd013af8d70fb21d3f940dab562b3c46a52&name=pushAdClickData!'